import { Expose, Transform, Type } from 'class-transformer';
import { Model } from './model';
import { UserType } from '../../common';
import { UsersReportsReasonsModel } from './user-reports-reasons-model';

export class UsersReportModel extends Model {
  @Expose() reporterName: string;
  @Expose() reportedType: UserType;
  @Expose() reportedName: string;
  @Expose() reportedId: string;
  @Expose() reportID: string;
  @Expose() message: string;
  @Expose() isInformed: boolean;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  date: Date | null;
  @Expose() comment: string;
  @Expose()
  @Type(() => UsersReportsReasonsModel)
  reasons: UsersReportsReasonsModel[];
}
